import * as types from "./actionTypes"

export function fetchOrganizationsData() {
    return {
        type: types.FETCH_ORGANIZATIONS_DATA,
    }
}

export function fetchOrganizationsSuccess(data) {
    return {
        type: types.FETCH_ORGANIZATIONS_DATA_SUCCESS,
        payload: data,
    }
}

export function fetchOrganizationsFailure() {
    return {
        type: types.FETCH_ORGANIZATIONS_DATA_FAILURE,
    }
}

export function fetchAccessRights(data) {
    return {
        type: types.FETCH_ACCESS_RIGHTS,
        payload: data,
    }
}

export function fetchAccessRightsSuccess(userPermissionData, userProfileData) {
    return {
        type: types.FETCH_ACCESS_RIGHTS_SUCCESS,
        userPermissionData: userPermissionData,
        userProfileData: userProfileData,
    }
}

export function fetchAccessRightsFailure() {
    return {
        type: types.FETCH_ACCESS_RIGHTS_FAILURE,
    }
}

export function selectShipper(shipper) {
    return {
        type: types.SELECT_SHIPPER,
        payload: shipper,
    }
}

export function checkEbolWOAccess() {
    return {
        type: types.CHECK_EBOL_WO_ACCESS,
    }
}

export function checkEbolWOAccessSuccess() {
    return {
        type: types.CHECK_EBOL_WO_ACCESS_SUCCESS,
    }
}

export function checkEbolWOAccessFailure() {
    return {
        type: types.CHECK_EBOL_WO_ACCESS_FAILURE,
    }
}

export function showEnhancedVisibilityMenu() {
    return {
        type: types.SHOW_ENHANCED_VISIBILITY_MENU,
    }
}

export function hideEnhancedVisibilityMenu() {
    return {
        type: types.HIDE_ENHANCED_VISIBILITY_MENU,
    }
}
